<app-settings-title [title]="'CARD'" (callback)="onBackClick()"></app-settings-title>

<app-section-entry 
        [title]="'CHANGE_ADDRESS.LABEL_CHANGE_ADDRESS'" 
        [target]="'/services/card/change-address'" 
        [hasAccess]="this.isChangeAddress" >
</app-section-entry>

<app-section-entry 
        [title]="'REPORT_LOST.LABEL_REPORT_LOST'" 
        [target]="'/services/card/report-lost'" 
        [hasAccess]="this.isReportLostCard">
</app-section-entry>

<app-section-entry 
        [title]="'SERVICE_CARD.MANAGE_CREDIT_CARD'" 
        [target]="'/services/card/manage-credit-card'"
        [hasAccess]="this.isManageCreditCard">
</app-section-entry>

<app-section-entry 
        [title]="'SERVICE_CARD.MANAGE_DEBIT_CARD'" 
        [target]="'/services/card/manage-debit-card'"
        [hasAccess]="this.isManageDebitCard">
</app-section-entry> 

<app-section-entry
        [title]="'SERVICE_CARD.MANAGE_CREDIT_MULTI_CARDS'"
        [target]="'/services/multi-card/manage-multi-card'"
        [extras]="{ queryParams: {cardType: MultiCardType.CREDIT} }"
        [hasAccess]="this.isManageMultiCreditCard">
</app-section-entry>

<app-section-entry
        [title]="'SERVICE_CARD.MANAGE_DEBIT_MULTI_CARDS'"
        [target]="'/services/multi-card/manage-multi-card'"
        [extras]="{ queryParams: {cardType: MultiCardType.DEBIT} }"
        [hasAccess]="this.isManageMultiDebitCard">
</app-section-entry>